
const fixed_header_css = {
  background: '#fff',
  'box-shadow': '0px 0px 10px 0px rgba(0,0,0,0.08)',
  height: '67px'
}

$('#navigation .navbar-nav .dropdown').hover(
  function() {
    if ($(window).width() >= 992) {
      $('#navigation').css('z-index', '1000')
      $(this).find('.dropdown-menu').stop().fadeIn('fast');
      $('.overlay').stop().fadeIn('10');
      // $('header .language').dropdown('hide');
    }
  },
  function() {
    if ($(window).width() >= 992) {
      $('#navigation').css('z-index', '')
      $(this).find('.dropdown-menu').stop().hide();
      $('.overlay').stop().hide();
      // $('header #lang').blur();
    }
  }
);

$(document).on('click', '#sidr-main .parent-category', function() {
  $('#sidr-main .parent-category').not(this).removeClass('dropdown-show').parent().find('.dropdown-menu').slideUp('fast');
  $('#sidr-main .parent-category').not(this).removeClass('dropdown-show').parent().find('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down')

  $(this).addClass('dropdown-show').parent().find('.dropdown-menu').slideToggle('fast');
  $(this).addClass('dropdown-show').parent().find('.parent-category .fas').toggleClass('fa-angle-down').toggleClass('fa-angle-up')

});

$(document).on('click', '#sidr-main .toggle-types', function(e){
  e.preventDefault();
  $('#sidr-main .toggle-types').not(this).next().slideUp('fast')
  $(this).next().slideToggle('fast')
});

$('.filters-second .navbar-nav .parent-category').on('click', function() {
  $('.parent-category').not(this).parent().find('.dropdown-menu').slideUp('fast');
  $('.parent-category').not(this).parent().find('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down')

  $(this).parent().find('.dropdown-menu').slideToggle('fast');
  $(this).parent().find('.icon').toggleClass('fa-angle-down').toggleClass('fa-angle-up');

  setTimeout(function(){
    $('html, body').animate({
      scrollTop: $(".parent-category .fa-angle-up").offset().top - 140
    }, 500);
  }, 200)
});


// $('#lang').focus(() => {
//   $('.overlay').stop().fadeIn();
// }).blur(() => {
//   $('.overlay').stop().fadeOut('fast');
//   $('header #lang').dropdown('hide');
// })
// let fc = 0;
// $('#lang-mobile').focus(() => {
//   $('.overlay').stop().fadeIn();
//   if ($(window).width() >= 768) {
//     // $('#lang-mobile').dropdown('show');
//   } else {
//     $('header .lang-mobile, header .lang-mobile .dropdown-menu').addClass('show');
//   }
// }).blur(() => {
//   $('.overlay').stop().fadeOut('fast');
//   if ($(window).width() >= 768) {
//     // $('#lang-mobile').dropdown('hide');
//   } else {
//     $('header .lang-mobile, header .lang-mobile .dropdown-menu').removeClass('show');
//   }
// })

$('.quick-cart, .mobile-cart-btn').on('click', function(e){
  e.preventDefault();
  $('.quick-cart-items').addClass('cart-active');
  $('.overlay').css('z-index', '1030');
  $('.overlay').fadeIn('fast');
  $('html, body').addClass('overflow-hidden');
  $('.mm-slideout').css('z-index', '1031');
});

$('.overlay, .close-cart, .close-filter').click(function (e) {
  e.preventDefault();
  removeOpenedWindows();
})

$('header .mobile-search-toggle, header .close-search').click(function (e) {
  e.preventDefault();
  if (!$('header .search-form').is(':visible')) {
    $('header .search-form').stop().slideDown('fast');
    $('header .search-form').find('input').focus();
    $('.overlay').fadeIn('fast');
    return
  }
  $('header .search-form').stop().slideUp('fast');
  $('.overlay').fadeOut('fast');
});


$(document).on('click', '.type-trigger-link', function(){
  $(this).addClass('active').find('.fa-circle').removeClass('far').addClass('fas');
});
